<template>
  <FormContainer withoutDivider>
    <template #title>Diplôme ou titre visé par le salarié(e)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_160"
          v-model="referenceInterneModel"
          label="Référence interne de l'entreprise"
          :required="meta.formation?.referenceFormationInterneEntreprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.referenceFormationInterneEntreprise?.$messageErreurDirty!"
          class="col-8 col-md-12 col-sm-36"
          hint="15 caractères maximum"
          :maxlength="15"
          deletable
          :readonly
          help="Ce champ vous permet de renseigner une référence propre à votre entreprise"
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_11"
          class="col-18 col-sm-36"
          v-model="typeQualificationModel"
          label="Type de qualification visée"
          :items="typeQualificationItems"
          :required="meta.formation?.typeQualification?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.typeQualification?.$messageErreurDirty!"
          :readonly
          :disabled="typeQualificationItems.length === 1"
        />
        <template v-if="estTypesQualificationsAutorisées('Cqp')">
          <WrapperToggleSwitch
            v-if="meta.formation?.typeReferentielFormation?.$status !== PropertyStatus.NotPresent"
            v-model="typeReferentielFormationModel"
            class="col-12 col-md-18 col-sm-36"
            label="Rechercher votre formation par"
            :items="typeReferentielFormationItems"
            :required="meta.formation?.typeReferentielFormation?.$status === PropertyStatus.Required"
            :alertLabel="meta.formation?.typeReferentielFormation?.$messageErreurDirty!"
            :readonly
          />
          <WrapperToggleSwitch
            v-else
            class="col-12 col-md-18 col-sm-36"
            label="Rechercher votre formation par"
            :items="typeReferentielFormationItems"
            disabled
          />
        </template>
      </div>
      <div
        class="form__bloc"
        v-if="estTypesQualificationsAutorisées('Rncp', 'Cqp')"
      >
        <WrapperAutocomplete
          v-if="meta.formation?.rncp?.code?.$status !== PropertyStatus.NotPresent"
          id="field_176"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          v-model="rncpModel"
          :search="searchRNCP"
          label="Code RNCP"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          :search-min-length="3"
          placeholder="Ex: boulangerie ou 39257"
          :readonly
          strict
          :required="meta.formation?.rncp?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.rncp?.code?.$messageErreurDirty!"
        />
        <WrapperAutocomplete
          v-else
          id="field_176"
          :search="searchRNCP"
          label="Code RNCP"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          placeholder="Ex: boulangerie ou 39257"
          disabled
        />
        <WrapperAutocomplete
          v-if="meta.formation?.formacode?.code?.$status !== PropertyStatus.NotPresent"
          id="field_177"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          v-model="formacodeModel"
          :search="searchFormacode"
          label="Formacode"
          class="col-18 col-sm-36"
          :search-min-length="3"
          placeholder="EX : boulangerie ou 45022108"
          :readonly
          strict
          :required="meta.formation?.formacode?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.formacode?.code?.$messageErreurDirty!"
        />
        <WrapperAutocomplete
          v-else
          id="field_177"
          :search="searchFormacode"
          label="Formacode"
          class="col-18 col-sm-36"
          placeholder="EX : boulangerie ou 45022108"
          disabled
        />
        <WarningRncp
          class="col-36"
          :rncp="rncpModel"
          :date-conclusion="dateConclusion"
          :isAvenant="isAvenant"
          :get-rncp
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperAutocomplete
          v-if="estNsfActif"
          id="field_16"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          v-model="nsfModel"
          :search="searchNsfSelonTypeQualification"
          label="Spécialité (NSF)"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          :search-min-length="estNsfSurRncp || estNsfSurFormacode ? 0 : 3"
          placeholder="Ex: Commercialisation de produits alimentaires ou 221w"
          :readonly
          strict
          :required="meta.formation?.nsf?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.nsf?.code?.$messageErreurDirty!"
        />
        <WrapperAutocomplete
          v-else
          id="field_16"
          :search="searchNsfSelonTypeQualification"
          label="Spécialité (NSF)"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          placeholder="Ex: Commercialisation de produits alimentaires ou 221w"
          disabled
          :required="meta.formation?.nsf?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.nsf?.code?.$messageErreurDirty!"
        />
        <WrapperDropdown
          id="field_17"
          v-model="diplomeModel"
          label="Diplôme ou titre visé "
          :required="meta.formation?.diplomeOuTitreVise?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.diplomeOuTitreVise?.$messageErreurDirty!"
          class="col-18 col-sm-36"
          :items="lov.Diplome"
          :readonly
          :disabled="!diplomeActif"
          key-id="code"
          key-label="intitule"
        />
        <WrapperInput
          id="field_160"
          v-model="intituleModel"
          label="Intitulé précis"
          :required="meta.formation?.intitule?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.intitule?.$messageErreurDirty!"
          class="col-36"
          :readonly
          :disabled="!estIntituleActif"
        />
      </div>
      <div class="form__bloc">
        <WrapperInputNumber
          id="field_161"
          v-model="dureeTotaleModel"
          label="Durée totale de formation"
          :required="meta.formation?.dureeTotale?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dureeTotale?.$messageErreurDirty!"
          class="col-8 col-md-8 col-sm-36"
          :decimal="2"
          deletable
          :readonly
        />
        <WrapperInputNumber
          id="field_162"
          v-model="dureeTotaleEnseignementModel"
          label="Dont durée des enseignements généraux professionnels et technologiques"
          :required="meta.formation?.dureeTotaleEnseignement?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dureeTotaleEnseignement?.$messageErreurDirty!"
          class="col-8 col-md-8 col-sm-36"
          :decimal="2"
          deletable
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import type { FormacodeDTO, LovItemDTO, RncpDto } from '@/features/api/extranet/dto/Lov'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { typeContratAvenant } from '@/features/domaine/regles-akto/CPRO'
  import {
    TypeQualification,
    TypeQualificationLibelle,
    TypeQualificationSousDispositif,
    TypeReferentielFormation,
  } from '@/features/domaine/types/opco/Demande/CPRO'
  import { CPRO_INJECT, type DemandeCproActions } from '@/features/interface/demande/cpro/DemandeCPRO.type'
  import { typeReferentielFormationItems } from '@/features/interface/demande/cpro/dropdown-items'
  import { useDemandeCPROStore } from '@/features/interface/demande/cpro/useDemandeCPROStore'
  import { FormContainer, WarningRncp } from '@/features/interface/demande/shared'
  import type { SearchNsf } from '@/features/services/demande/DemandeAllService.types'
  import { objectExtract } from '@/features/shared/tools'
  import { storeToRefs } from 'pinia'
  import { computed, inject, ref } from 'vue'

  const { searchRNCP, searchFormacode, searchNsf } = inject<DemandeCproActions>(CPRO_INJECT)!
  const store = useDemandeCPROStore()
  const { setupFieldWithKey, setupFieldWithOptions } = store
  const { model, meta, readonly, lov } = storeToRefs(store)

  const referenceInterneModel = setupFieldWithKey<string>('formation.referenceFormationInterneEntreprise', true)

  const typeQualificationModel = setupFieldWithOptions<TypeQualification | null>({
    getValue: () => model.value?.formation!.typeQualification ?? null,
    setPatch: (patch, value) => {
      patch.formation!.typeQualification = value
      if (value === 'ClassificationsCcn') {
        patch.formation!.diplomeOuTitreVise = 'AucunDiplomeNiTitre'
      }
      // reset de la saisie
      patch.formation!.rncp = null
      patch.formation!.formacode = null
      patch.formation!.nsf = null
      patch.formation!.intitule = null
    },
  })
  const typesQualificationsAutorisées = ref(TypeQualificationSousDispositif[model.value!.sousDispositif!] ?? [])
  const estTypesQualificationsAutorisées = (...typeQualifications: TypeQualification[]) =>
    typeQualifications.some((code) => typesQualificationsAutorisées.value.includes(code))

  const typeQualificationItems = computed(() => {
    return Object.entries(TypeQualificationLibelle)
      .filter(([code, _]) => typesQualificationsAutorisées.value.includes(code as TypeQualification))
      .map(([id, label]) => ({ id, label }))
  })

  const typeReferentielFormationModel = setupFieldWithOptions<TypeReferentielFormation | null>({
    getValue: () => model.value?.formation?.typeReferentielFormation ?? null,
    setPatch(patch, value) {
      patch.formation!.typeReferentielFormation = value

      patch.formation!.rncp = null
      patch.formation!.formacode = null
      patch.formation!.nsf = null
      patch.formation!.intitule = null
    },
  })

  const rncpModel = setupFieldWithOptions<LovItemDTO<string> | null>({
    getValue: () => model.value?.formation?.rncp ?? null,
    setPatch: (patch, value) => {
      patch.formation!.rncp = value ? objectExtract(value, ['code', 'intitule']) : null
      if (value?.code) {
        patch.formation!.intitule = value?.intitule
        const rncp = value as RncpDto
        if (rncp.nsf?.length === 1) {
          patch.formation!.nsf = rncp.nsf.at(0)
        }
      } else {
        patch.formation!.intitule = null
      }
    },
  })

  const formacodeModel = setupFieldWithOptions<LovItemDTO<string> | null>({
    getValue: (model) => model.formation?.formacode ?? null,
    setPatch: (patch, value) => {
      patch.formation!.formacode = value ? objectExtract(value, ['code', 'intitule']) : null
      if (value?.code) {
        const formacode = value as FormacodeDTO
        if (formacode.nsf?.length === 1) {
          patch.formation!.nsf = formacode.nsf.at(0)
        }
      }
    },
  })

  const diplomeModel = setupFieldWithKey<string>('formation.diplomeOuTitreVise')
  const diplomeActif = computed(
    () => typeQualificationModel.value && typeQualificationModel.value !== 'ClassificationsCcn',
  )

  const intituleModel = setupFieldWithKey<string>('formation.intitule')
  const estIntituleActif = computed(() => {
    if (!typeQualificationModel.value) return false
    if (typeQualificationModel.value === 'Rncp') return false
    if (typeQualificationModel.value === 'Cqp') {
      return (typeReferentielFormationModel.value ?? 'Rncp') !== 'Rncp'
    }
    return true
  })

  const nsfModel = setupFieldWithOptions<LovItemDTO<string> | null>({
    getValue: (model) => model.formation?.nsf ?? null,
    setPatch: (patch, value) => {
      patch.formation!.nsf = value ? objectExtract(value, ['code', 'intitule']) : null
    },
  })
  const estNsfSurRncp = computed(
    () =>
      typeQualificationModel.value === 'Rncp' ||
      (typeQualificationModel.value === 'Cqp' && typeReferentielFormationModel.value === 'Rncp'),
  )
  const estNsfSurFormacode = computed(
    () => typeQualificationModel.value === 'Cqp' && typeReferentielFormationModel.value === 'Formacode',
  )
  const estNsfActif = computed(() => {
    if (estNsfSurRncp.value) return !!rncpModel.value?.code
    if (estNsfSurFormacode.value) return !!formacodeModel.value?.code
    return typeQualificationModel.value === 'ClassificationsCcn'
  })
  const searchNsfSelonTypeQualification = (search: string) => {
    const query: SearchNsf = { search }
    if (estNsfSurRncp.value) {
      query.codeRNCP = rncpModel.value?.code
    } else if (estNsfSurFormacode.value) {
      query.codeFormacode = formacodeModel.value?.code
    }
    return searchNsf(query)
  }

  const getLabel = function (value: LovItemDTO<string>) {
    return `${value.code} - ${value.intitule}`
  }

  const { getRncp } = inject<DemandeCproActions>(CPRO_INJECT)!
  const dateConclusion = computed(() => model.value?.contrat?.dateConclusion)
  const isAvenant = computed(() => typeContratAvenant.includes(model.value!.contrat!.typeContratAvenant!))

  const dureeTotaleModel = setupFieldWithKey<string>('formation.dureeTotale', true)
  const dureeTotaleEnseignementModel = setupFieldWithKey<string>('formation.dureeTotaleEnseignement', true)
</script>
